// Normalize a user-entered URL for storage. Trims surrounding whitespace and,
// when a non-empty value has no scheme, assumes https:// — so a pasted
// "app.hubspot.com/deal/123" becomes a valid absolute URL. An empty value
// stays empty ("not set"). The backend still hard-validates the result.
export function normalizeUrl(value) {
  const trimmed = (value || '').trim();
  if (!trimmed) return '';
  if (/^[a-z][a-z0-9+.-]*:\/\//i.test(trimmed)) return trimmed;
  return `https://${trimmed}`;
}

// True when `value` is an http(s) URL — the guard before putting a stored
// value into a clickable href.
export function isWebUrl(value) {
  try {
    const { protocol } = new URL(value);
    return protocol === 'http:' || protocol === 'https:';
  } catch {
    return false;
  }
}

// True when `value` is an http(s) link on a hubspot.com host (any subdomain).
// Mirrors the backend guard in routes/admin.js so the UI rejects a non-HubSpot
// link (e.g. "https://seznam") or a hostile scheme (e.g.
// "javascript://hubspot.com/...") before the request round-trips.
export function isHubspotUrl(value) {
  try {
    const { protocol, hostname } = new URL(value);
    if (protocol !== 'http:' && protocol !== 'https:') return false;
    return hostname === 'hubspot.com' || hostname.endsWith('.hubspot.com');
  } catch {
    return false;
  }
}
